import styled, { css } from 'styled-components';

import React from 'react';
import { MobileScreen } from '../../styles/ConstantMediaQuery';

export const AccordionItemContent = styled.div`
    transform-origin: top;
    transition: max-height 0.5s ease 0s;

    ${({ isVisible }) => !isVisible && css`
        max-height: 0;
        overflow: hidden;
    `}
`;

export const Content = styled.div`
    display: flex;
    align-items: center;

    @media ${MobileScreen} {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const Title = styled.div`
    margin-right: 5px;
`;

export const Subtitle = styled.div`
    font-size: 12px;
`;

export const renderMenuContent = (title, subtitle) => (
    <Content>
        {title && (
            <Title>
                {title}
            </Title>
        )}
        {subtitle && (
            <Subtitle>
                {subtitle}
            </Subtitle>
        )}
    </Content>
);

export const DefaultRenderComponent = ({ value }: {value: string}) => (<div>{value}</div>);
